
import { defineComponent } from 'vue'
import { iDataset, iFunction, iInputColumn } from '../../../../FunctionsCatalog'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import FunctionsCatalogDatasetFormColumnsTable from './FunctionsCatalogDatasetFormColumnsTable.vue'
import FunctionsCatalogDatasetFormVariablesTable from './FunctionsCatalogDatasetFormVariablesTable.vue'
import FunctionsCatalogDatasetEnvironmentTable from './FunctionsCatalogDatasetEnvironmentTable.vue'
import FunctionsCatalogParametersForm from './FunctionsCatalogParametersForm.vue'

export default defineComponent({
    name: 'function-catalog-dateset-form',
    components: { Accordion, AccordionTab, Card, Dropdown, FunctionsCatalogDatasetFormColumnsTable, FunctionsCatalogDatasetFormVariablesTable, FunctionsCatalogDatasetEnvironmentTable, FunctionsCatalogParametersForm },
    props: { selectedDataset: { type: Object }, propFunction: { type: Object }, pythonEnvironments: { type: Array }, rEnvironments: { type: Array }, libraries: { type: Array } },
    emits: ['environmentSelected'],
    data() {
        return {
            selectedFunction: {} as iFunction,
            dataset: {} as iDataset,
            datasetColumns: [] as any[],
            selectedEnvironment: null
        }
    },
    watch: {
        selectedDataset() {
            this.loadDataset()
        }
    },
    created() {
        this.loadDataset()
        this.loadFunction()
    },
    methods: {
        loadDataset() {
            this.dataset = this.selectedDataset as iDataset
            if (this.dataset && this.dataset.meta) {
                this.getDatasetColumns()
            }
            this.clearInputColumnDatasetColumn()
        },
        loadFunction() {
            this.selectedFunction = this.propFunction as iFunction
        },
        getDatasetColumns() {
            this.datasetColumns = []
            for (let i = 2; i < this.dataset.meta.columns.length; i++) {
                if (this.dataset.meta.columns[i].pname === 'fieldAlias') {
                    this.datasetColumns.push(this.dataset.meta.columns[i].pvalue)
                }
            }
        },
        clearInputColumnDatasetColumn() {
            this.selectedFunction.inputColumns?.forEach((el: iInputColumn) => (el.dsColumn = ''))
        }
    }
})
